<div class="track-list">
  @for (day of getUniqueDays(); track day) {
  <div class="track-list__day-wrapper">
    <div class="track-list__day">
      <div class="track-list__heading">{{ formatDay(day) }}</div>
      @for (entry of getItemsByDay(day); track entry.id) {
      <div class="track-list__item">
        <app-track-entry class="track-list__entry" [trackEntry]="entry" [projects]="projects()" [tags]="tags()"
          [users]="users()" [showUser]="showUsers()" (delete)="deleteItem($event)"
          (updateEntry)="updateEntry($event)" (duplicateEntry)="duplicateEntry($event)"></app-track-entry>
      </div>
      }
    </div>
  </div>
  }
</div>
@if (hasMorePages()) {
  <div class="track-list__pager">
    <button class="track-list__button" (click)='checkExtendedItems(); loadMore()'>Load More</button>
  </div>
}
